export default "__VITE_ASSET__BHMlR6eb__"